import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { CollectionService } from './services/collection.service';
import { QuerystringService } from './services/querystring.service';
import { MapService } from './services/map.service';

import { AppComponent } from './app.component';
import { MiniMapComponent } from './mini-map/mini-map.component';
import { FullMapComponent } from './full-map/full-map.component';
import { InfoWindowCardComponent } from './info-window-card/info-window-card.component';
import { GroupedInfoWindowCardComponent } from './grouped-info-window-card/grouped-info-window-card.component';

@NgModule({
  declarations: [
    AppComponent,
    MiniMapComponent,
    FullMapComponent,
    InfoWindowCardComponent,
    GroupedInfoWindowCardComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    AgmCoreModule.forRoot({
      //apiKey: 'AIzaSyC5t9TLHJXW6MYjSbaII8Y3TVItbrdclB4', // test
      apiKey: 'AIzaSyC41JEaRGSx3d7fVlTxDlgDgK1BhH2STBU', // prod
      libraries: ['places']
    }),
    SlickCarouselModule
  ],
  providers: [
    CollectionService,
    QuerystringService,
    MapService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
